import React from "react";
import { Card, Tag } from "antd";
import {
  Item,
  ItemImage,
  ItemDetails,
  ItemSubtitle,
  ItemHighlights,
  ItemTagsWrap,
} from "./styles/ProjectSection";
import { EyeOutlined, GithubFilled } from "@ant-design/icons";
import getRandomTagColor from "./helpers/getRandomTagColor";
import { FormattedMessage } from "react-intl";
const { Meta } = Card;

const getActions = (name, github, link) => [
  ...(github
    ? [
        <a
          href={github}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} on GitHub`}
        >
          <GithubFilled key="github" />
        </a>,
      ]
    : []),
  ...(link
    ? [
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${name} live site`}
        >
          <EyeOutlined key="link" />
        </a>,
      ]
    : []),
];

const Project = ({
  name,
  link,
  github,
  imageSrc,
  subtitle,
  description,
  highlights,
  tags,
}) => (
  <Item>
    <ItemTagsWrap>
      {tags.map((tag) => (
        <Tag key={tag} color={getRandomTagColor()}>
          {tag}
        </Tag>
      ))}
    </ItemTagsWrap>
    <Card
      hoverable
      cover={
        <ItemImage>
          <img alt="" src={imageSrc} />
        </ItemImage>
      }
      actions={getActions(name, github, link)}
    >
      <Meta
        title={name}
        description={
          <ItemDetails>
            <ItemSubtitle>
              <FormattedMessage {...subtitle} />
            </ItemSubtitle>
            <p>
              <FormattedMessage {...description} />
            </p>
            <ItemHighlights>
              {highlights.map((highlight) => (
                <li key={highlight.id}>
                  <FormattedMessage {...highlight} />
                </li>
              ))}
            </ItemHighlights>
          </ItemDetails>
        }
      />
    </Card>
  </Item>
);

export default Project;
